import { Routes, RouterModule } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'danhmuc',
    loadChildren: () => import('../../views/danhmuc/danhmuc.module').then(m => m.DanhMucModule)
  },
  {
    path: 'dongbo',
    loadChildren: () => import('../../views/dongbo/dong-bo-du-lieu.module').then(m => m.DongBoDuLieuModule)
  }
];
